import {ChannelPreview, ChannelPreviewProps} from "@webng/comments"
import React from "react";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import { PollContentBlockProps, PollContentBlockView } from "../content/PollContentBlockView";

const queryClient = new QueryClient();

export function ChannelPreviewWrapper(props: ChannelPreviewProps) {

  return <QueryClientProvider client={queryClient}>
    <ChannelPreview {...props} />
  </QueryClientProvider>
}

export function PollContentBlockWrapper(props: PollContentBlockProps) {

  return <QueryClientProvider client={queryClient}>
    <PollContentBlockView {...props} />
  </QueryClientProvider>
}

export type PollContentBlockPropsExport = PollContentBlockProps
